// services/estimates.js
import axiosInstance from './axiosInstance';

const ESTIMATES_API_URL = '/estimates';

const estimatesService = {
  async get(idempresa, produto = '') {
    try {
      const produtoParam = produto ? `&produto=${produto}` : '';
      const response = await axiosInstance.get(`${ESTIMATES_API_URL}/get.php?idempresa=${idempresa}${produtoParam}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter estimativas:', error);
      return [];
    }
  },

  async set(estimateData) {
    try {
      const response = await axiosInstance.post(`${ESTIMATES_API_URL}/set.php`, estimateData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar estimativa:', error);
      throw error;
    }
  },

  async unset(idempresa, produto) {
    try {
      const response = await axiosInstance.get(`${ESTIMATES_API_URL}/unset.php?idempresa=${idempresa}&produto=${produto}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao remover estimativa:', error);
      throw error;
    }
  }
};

export default estimatesService;
